<div class="gridContainer" [style.color]="color">
  <div class="gridItem">
    <h4>Distance</h4>
    <h2>{{activity.distance | distance: 'show'}}</h2>
  </div>
  <div class="gridItem">
    <h4>Avg. Pace</h4>
    <h2>{{activity.pace | elapsed : 'km'}}</h2>
  </div>
  <div class="gridItem">
    <h4>Moving Time</h4>
    <h2>{{activity.moving_time | elapsed}}</h2>
  </div>
  <div class="gridItem">
    <h4>Elevation Gain</h4>
    <h2>{{activity.total_elevation_gain}} m</h2>
  </div>
  <div class="gridItem">
    <h4>Calories</h4>
    <h2>{{activity.calories}} Cal</h2>
  </div>
  <div class="gridItem">
    <h4>Avg Heart Rate</h4>
    <h2>{{activity.average_heartrate |  number: '1.0-0'}} bpm</h2>
  </div>
</div>